import React from 'react';
import Nav from './components/Nav';
import { LightboxProvider } from './components/Media';
import Hero from './sections/Hero';
import Work from './sections/Work';
import Galleries from './sections/Galleries';
import Background from './sections/Background';
import Contact from './sections/Contact';

export default function App() {
  return (
    <LightboxProvider>
      <Nav />
      <main>
        <Hero />
        <Work />
        <Galleries />
        <Background />
        <Contact />
      </main>
    </LightboxProvider>
  );
}
